import React, { Component } from 'react';

import { observer, inject } from 'mobx-react';

import LoginScreen from './LoginScreen';
import Dashboard from './dashboard';
import About from './About';

import LooseLeafUI from './looseLeaf/LooseLeafUI';
import LooseLeafConfiguration from "./looseLeaf/LooseLeafConfiguration";


@inject("appStore")
@observer
class SelectedComponent extends Component {

    evaluateComponent() {
        const appStore = this.props.appStore;
        switch (appStore.currentComponent.key) {
            case 'awaitingSeeds': {
                return <LooseLeafUI key="awaiting" context="awaiting" />;
            }
            case 'activeSeeds': {
                return <LooseLeafUI key="active" context="active" />;
            }
            case 'plannedSeeds': {
                return <LooseLeafUI key="planned" context="planned" />;
            }
            case 'looseLeafConfiguration': {
                return <LooseLeafConfiguration />
            }
            case 'Login': {
                return <LoginScreen />;
            }
            case 'About': {
                return <About />;
            }
            case 'dashboard':
                return <Dashboard />;
            default: {
                return <About />;
            }
        }
    }

    render() {
        return (this.evaluateComponent());
    }
}


export default SelectedComponent;
